<template>
  <div class="sort is-flex" :class="{'hide' : showCreate}">
    <div v-if="!isGrid && $isEngCom" class="is-flex">
      <a v-if="$i18n.locale === 'en'" class="button sort-title is-uppercase" v-html="collapseButtonContent" @click="toggleRepliesOnClick"></a>
    </div>
    <div v-if="canReorder || (showReorder && !reorderMode)" class="is-marginless is-flex" @click="$emit('enterReorderMode')"><a class="button sort-title is-uppercase" tabindex="0" @keypress.enter.space="$emit('enterReorderMode')" qa="reorder-btn"><i class="fas fa-sync"></i>&nbsp; {{ $t("projectPage.reorder") }}</a></div>
    <div v-if="!isMobile && reorderMode && isGrid && !$isApp && !postLimitExceeded && !isProjectSubmitted || (showReorder && reorderMode)" class="is-marginless is-flex">
      <div class="is-flex" @click="$emit('resetPosts')"><a class="cancel-button button is-rounded is-outlined sort-title is-uppercase" tabindex="0" @keypress.enter.space="$emit('resetPosts')" > {{ $t("cancel") }}</a></div>
      <div class="is-flex" @click="$emit('savePosts')"><a class="save-button button is-rounded is-primary is-outlined sort-title is-uppercase" tabindex="0" @keypress.enter.space="$emit('savePosts')"> {{ $t("projectPage.save") }}</a></div>
    </div>
    <div v-if="showSort && !reorderMode" class="sort-button is-flex">
      <a class="button sort-title is-uppercase"
         v-html="orderButtonContent"
         tabindex="0"
         @keypress.enter.space="sortPostsOnClick"
         @click="sortPostsOnClick"
         qa="preset-sort-btn" />
    </div>
  </div>
</template>

<script>
import componentState from '@/mixins/component-state'
import state from '../state'
import mixin from '../tabs'
import breakpoints from '@/libs/breakpoints'
import i18n from '@/i18n'
import auth from '@/mixins/auth'

export default {
  mixins: [componentState, mixin, auth],
  props: ['reorderMode', 'tab', 'postLimitExceeded', 'showCreate', 'projectRole'],
  computed: {
    orderButtonContent: function () {
      const lastToFirst = i18n.t('projectPage.lastToFirst') + '&nbsp;<i class="fal fa-chevron-down"></i>'
      const firstToLast = i18n.t('projectPage.firstToLast') + '&nbsp;<i class="fal fa-chevron-up"></i>'
      return this.isSortedNewestFirst ? lastToFirst : firstToLast
    },
    collapseButtonContent: function () {
      return this.repliesExpanded ? i18n.t('projectPage.collapseReplies') : i18n.t('projectPage.expandReplies')
    },
    isGrid: function () {
      return this.tab === 'grid'
    },
    isMobile: function () {
      return breakpoints.isMobile()
    },
    isProjectSubmitted: function () {
      return this.project.submitted
    },
    showReorder: function () {
      return !this.isMobile && (this.isAdmin || ['anonAdmin', 'anonCoordinator'].includes(this.projectRole))
    },
    canReorder: function () {
      return !this.isMobile && this.project.reorder && !this.reorderMode && this.isGrid && !this.$isApp && !this.postLimitExceeded && this.canEditProject && !this.isProjectSubmitted
    },
    customPostOrder: function () {
      return this._get(state.posts.customPostOrder, false)
    },
    showSort: function () {
      return this.project.reorder && !this.customPostOrder
    }
  },
  methods: {
    sortPostsOnClick: function () {
      // We defaulted first to last (likely because this was a template), but now that they clicked the button, remove that default
      if (this._get(state.project.defaultFirstToLast)) {
        this._set(state.project.defaultFirstToLast, false)
      } else {
        this._callback(state.posts.sort)
      }
    },
    toggleRepliesOnClick: function () {
      this._callback(state.posts.toggleReplies)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~styles/utils.scss';

.sort {
  padding: 1rem;
  position: absolute;
  top: -80px;
  right: 0;
  @include mobile {
    justify-content: center;
    padding: 1rem 0;
    margin-right: 1rem;
    a {
      font-size: 8px;
    }
  }
}
.hide {
  display: none !important;
}
.sort-title {
  height: 100%;
  align-items: center;
  justify-content: center;
  color: $grey-dark;
  font-size: 0.6rem;
  padding: calc(0.375em - 1px) 0.75em;
  @include mobile {
    font-size: 0.55rem;
  }
}

.cancel-button {
  margin-right: .5rem;
}

.sort-button {
  margin-left: .5rem;
}

.button {
  border-radius: 0;
}
</style>
